import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  AppBar, Avatar, Box, IconButton, Menu, MenuItem, Stack, Toolbar, Typography, Button,
} from "@mui/material";
import StorefrontIcon from "@mui/icons-material/Storefront";
import LogoutIcon from "@mui/icons-material/Logout";
import StoreIcon from "@mui/icons-material/StoreMallDirectoryOutlined";
import { BRAND } from "../theme";
import { useAuth } from "../auth/AuthContext";

/** Slim top bar for the buyer's standalone pages (orders list / detail). */
const BuyerShell: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const navigate = useNavigate();
  const { displayName, username, logout } = useAuth();
  const [anchor, setAnchor] = useState<null | HTMLElement>(null);
  const name = displayName || username || "My Business";

  return (
    <Box sx={{ bgcolor: BRAND.surface, minHeight: "100vh" }}>
      <AppBar position="sticky" elevation={0} color="inherit" sx={{ bgcolor: "#fff", borderBottom: "1px solid", borderColor: "divider" }}>
        <Toolbar sx={{ gap: 1, flexWrap: "wrap" }}>
          <Stack direction="row" alignItems="center" spacing={1} sx={{ color: BRAND.green }}>
            <StorefrontIcon />
            <Typography variant="h6" sx={{ color: BRAND.green }}>Food Wholesale</Typography>
          </Stack>
          <Box sx={{ flex: 1 }} />
          <Button startIcon={<StoreIcon />} onClick={() => navigate("/catalogue")} sx={{ textTransform: "none" }}>
            Catalogue
          </Button>
          <IconButton onClick={(e) => setAnchor(e.currentTarget)} aria-label="Account menu">
            <Avatar sx={{ width: 32, height: 32, bgcolor: BRAND.green }}>{name.slice(0, 1).toUpperCase()}</Avatar>
          </IconButton>
          <Menu anchorEl={anchor} open={!!anchor} onClose={() => setAnchor(null)}>
            <MenuItem onClick={() => { setAnchor(null); navigate("/catalogue"); }}>Back to catalogue</MenuItem>
            <MenuItem onClick={logout}><LogoutIcon fontSize="small" style={{ marginRight: 8 }} />Sign out</MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>
      <Box sx={{ p: { xs: 2, md: 3 }, maxWidth: 1100, mx: "auto" }}>{children}</Box>
    </Box>
  );
};

export default BuyerShell;
